exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar[data-v-2fa7f787]{background-size:10% auto;background:url(" + require("assets/header_orange_bg.png") + ");background-repeat:repeat;border-bottom:3px solid #ea502e}.navbar .navbar-brand[data-v-2fa7f787]{max-width:400px;position:absolute;left:0;bottom:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2fa7f787&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/partials/GuestHeader/PCHeader.vue
// module id = 500
// module chunks = 0